import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type ILocationNode = {
  id: number;
  name: string;
  divisionId: number;
  groupId: number;
  employerId: number;
  clientId: number;
};

type locationState = {
  list: ILocationNode[] | [];
};

const initialState: locationState = { list: [] };

const slice = createSlice({
  name: "locations",
  initialState,
  reducers: {
    setLocationsList(state, action: PayloadAction<locationState>) {
      state.list = action.payload.list ?? [];
    },
    clearLocations(state) {
      state.list = [];
    },
  },
});

export const { setLocationsList, clearLocations } = slice.actions;
export default slice.reducer;
